import angular from 'angular';
import template from './talentExpertSourcingProductivityView.html';

export class TalentExpertSourcingProductivityComponent {
    /* @ngInject */
    constructor() {
        const talentExpertSourcingProductivityCtrl = this;
        talentExpertSourcingProductivityCtrl.init = function () {

        };

        talentExpertSourcingProductivityCtrl.init();
    }
}

export const TalentExpertSourcingProductivityComponentConfiguration = {
    template,
    controller: TalentExpertSourcingProductivityComponent,
    controllerAs: 'talentExpertSourcingProductivityCtrl',
};

angular
    .module('TALENYA-FE')
    .component('talentExpertSourcingProductivityComponent', TalentExpertSourcingProductivityComponentConfiguration);
